export default class extends Controller {
  static targets = ['primaryAsset']

  connect() {
    this.data.set('image', this.element.getAttribute('data-image-selector'))
  }

  showPrimaryAsset() {
    App.Modal.open({ content: this.primaryAssetTarget.innerHTML })
  }

  get imageSelector() {
    return this.data.get('image')
  }
}



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/promotions/promotions-card-controller.js